export default "__VITE_ASSET__cJajqaLK__"